<template>
  <div class="price-inquiry-detail">
    <div class="content">
         <!-- <el-empty description="暂无数据"></el-empty> -->
         	<el-form class="prod-form" label-width="140px"  ref="priceIquiryForm" size="small" :model="formData">
        <div style="display:flex;align-items:center;padding:10px;box-shadow:0px 2px #eee">
            <el-button @click="goBack" style="margin-bottom:18px;">返回</el-button>
            <el-form-item  label="询价标题：" prop="inquiryTitle">
                <el-input v-model="formData.inquiryTitle"  type="text"  placeholder="请输入询价标题" style="width:500px;"></el-input>
            </el-form-item>
            <el-form-item>
            </el-form-item>
        </div>
        <div style="display: flex;align-items:center;">
            <div class="form-content">
              <el-card class="box-card">
                <div slot="header" class="header">
                  <span>产品信息</span>
                </div>
               <div style="display: flex;align-items:center;">
                <div>
                  <el-form-item label="产品名称及型号" prop="productNameModel">
                    <el-input v-model="formData.productNameModel"  type="text"  :readonly="true"  style="width:500px;"></el-input>
                  </el-form-item>
                   <el-form-item label="规格与技术参数" prop="specificationsParameters">
                    <el-input v-model="formData.specificationsParameters"  type="text"  :readonly="true"  style="width:500px;"></el-input>
                    
                  </el-form-item>
                   <el-form-item label="执行标准" prop="executionStandard">
                    <el-input v-model="formData.executionStandard"  type="text"  :readonly="true"  style="width:500px;"></el-input>
                  </el-form-item>
                </div>
                <div style="margin-left:20px;">

                  <!-- <el-form-item> -->
                    <div class="upload-box"><img width="148px" :src="imgUrl"/></div>
                  <!-- </el-form-item> -->
                </div>
               </div>
              </el-card>
               <el-card class="box-card">
                <div slot="header" class="header">
                  <span>采购数量与需求周期</span>
                </div>
               <div style="display: flex;align-items:center;">
                <div>
                  <el-form-item label="本次预计采购数量" prop="estimatedPurchaseQuantity">
                    <el-input v-model="formData.estimatedPurchaseQuantity"  type="text"  :readonly="true"  style="width:250px;"></el-input>
                  </el-form-item>
                   <el-form-item label="要求交货时间" prop="requiredDeliveryTime">
                    <el-input v-model="formData.requiredDeliveryTime"  type="text"  :readonly="true"  style="width:250px;"></el-input>
                  </el-form-item>
                   <el-form-item label="要求运输方式" prop="transportRequirements	">
                    <el-input v-model="formData.transportRequirements	"  type="text"  :readonly="true"  style="width:250px;"></el-input>
                     
                  </el-form-item>
                </div>
                <div>
                  <el-form-item label="单位" prop="unit">
                    <el-input v-model="formData.unit"  type="text"  :readonly="true"  style="width:250px;"></el-input>
                     
                  </el-form-item>
                   <el-form-item label="交货地点" prop="deliveryLocation">
                    <el-input v-model="formData.deliveryLocation"  type="text"  :readonly="true"  style="width:250px;"></el-input>
                   
                  </el-form-item>
                   <el-form-item label="包装需求" prop="packagingRequirements">
                    <el-input v-model="formData.packagingRequirements"  type="text"  :readonly="true"  style="width:250px;"></el-input>
                    
                  </el-form-item>
                </div>
               </div>
              </el-card>
               <el-card class="box-card">
                <div slot="header" class="header">
                  <span>质量验收与付款结算</span>
                </div>
               <div style="display: flex;align-items:center;">
                <div>
                  <el-form-item label="质量标准" prop="qualityStandard">
                    <el-input v-model="formData.qualityStandard"  type="text"  :readonly="true"  style="width:250px;"></el-input>
                    
                  </el-form-item>
                   <el-form-item label="付款方式" prop="paymentMethod">
                    <el-input v-model="formData.paymentMethod"  type="text"  :readonly="true"  style="width:250px;"></el-input>
                   
                  </el-form-item>
                </div>
                <div>
                  <el-form-item label="验收方式" prop="inspectionMethod">
                    <el-input v-model="formData.inspectionMethod"  type="text"  :readonly="true"  style="width:250px;"></el-input>
                    
                  </el-form-item>
                   <el-form-item label="报价有效期" prop="quotationValidityPeriod">
                    <el-input v-model="formData.quotationValidityPeriod"  type="text"  :readonly="true"  style="width:250px;"></el-input>
                   
                  </el-form-item>
                </div>
               </div>
              </el-card>
              <el-card class="box-card">
                <div slot="header" class="header">
                  <span>附加信息与附件</span>
                </div>
               <div style="display: flex;align-items:center;">
                <div>
                  <el-form-item label="是否需要图纸或样品" prop="needDrawingsSamples">
                    <el-input v-model="formData.needDrawingsSamples"  type="text"  :readonly="true"  style="width:250px;"></el-input>
                    
                  </el-form-item>
                </div>
                <div>
                  <el-form-item label="其他特殊要求" prop="otherSpecialRequirements">
                    <el-input v-model="formData.otherSpecialRequirements"  type="text"  :readonly="true"  style="width:250px;"></el-input>
                    
                  </el-form-item>
                </div>
               </div>
               <hr />
               <div>联系方式：</div>
                <div style="display: flex;align-items:center;">
                <div>
                  <el-form-item label="姓名" prop="contactName">
                    <el-input v-model="formData.contactName"  type="text"  :readonly="true"  style="width:150px;"></el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item label="联系电话" prop="contactPhone">
                    <el-input v-model="formData.contactPhone"  type="text"  :readonly="true"  style="width:150px;"></el-input>
                  </el-form-item>
                </div>
                 <div>
                  <el-form-item label="邮箱" prop="email">
                    <el-input v-model="formData.email"  type="text"  :readonly="true"  style="width:150px;"></el-input>
                  </el-form-item>
                </div>
               </div>
              </el-card>
            </div>
            <div class="right-dir  position-relative md-el-aside" v-resize-width>
              <div class="suplier-title">供应商列表</div>
              <div>
                  <el-checkbox-group 
                    v-model="formData.inquiryCompanyIds"
                  >
                    <div  v-for="(item,idx) in supplierList" class="checkbox-item" :title="item.compName" :key="idx">
                      <el-checkbox checked :label="item.iD" :readonly="true"  :key="item.iD">{{item.compName}}</el-checkbox>
                    </div>
                  </el-checkbox-group>
              </div>
               <div style="flex: 1;cursor: auto;"></div>
            </div>
        </div>
        </el-form>
    </div>
  </div>
</template>

<script>
import {ApiService} from '@/libs'
import { PriceQuiryService} from '@/service'


export default {
  data() {
    return {
      supplierList: [],
      eidtId: '',
      isDetail: '', // 
      // dirID:'',
      // dirName:'',
      formData: {
        inquiryTitle: '',
        inquiryCompanyIds: [], // 供应商
        productNameModel:'',
        specificationsParameters:'',
        executionStandard:'',
        estimatedPurchaseQuantity:'',
        requiredDeliveryTime:'',
        transportRequirements:'',
        unit:'',
        deliveryLocation:'',
        packagingRequirements:'',
        qualityStandard:'',
        paymentMethod:'',
        inspectionMethod:'', 
        quotationValidityPeriod:'',
        needDrawingsSamples:'',
        otherSpecialRequirements:'',
        contactName:'', 
        contactPhone:'',
        email:'',
      },
      imgUrl: '', // obs 生成的地址
      obsKey: '', // obs 生成的key
      domain:  `${ApiService.ImageHost}`,
      domain2:  `${ApiService.OssLook}`,
    }
  },
  components: { },
  mounted() {
    this.eidtId = this.$route.query.id||'';
    this.isDetail = this.$route.query.type||'';
    this.getEditData();
  },
  methods: {
   goBack() {
      this.$router.push({
        path: '/priceInquiry/home', 
        query: {
          dirType: this.$route.query.dirType||'1',
        }
      });
   },
   // 编辑进入页面处理
   async getEditData() {
    const id = this.$route.query.id;
    if(id) {
      const res = await PriceQuiryService.getInquiryDetail({id});
      if(res.data) {
        const keys = Object.keys(this.formData);
        for(let key of keys) {
          this.formData[key] = res.data[key] ||(key === 'inquiryCompanyIds' ? []: '');
        }
        const urlKey = res.data?.inquiryImages?.key||'';
        this.obsKey = urlKey;
        const strArr = ['prod/', 'series/', 'logo/', 'mx/', 'yb/', 'sw/', 'wx/', 'images/'];
        const containsAny = strArr.some(str => (urlKey|| '').includes(str));
          if(containsAny) {
            this.imgUrl =`${this.domain}/${urlKey}_265x265.jpg`;
          }else {
            this.imgUrl =`${this.domain2}/${urlKey}?x-oss-process=image/resize,w_300`
          }
        // this.imgUrl = urlKey? `${ApiService.OssLook}/${urlKey}`: '';
        this.supplierList = res.data.inquiryCompanyList || [];

      }
    }
   },
  }
}
</script>

<style lang="less" scoped>

.search-input{
  margin: 10px 0;
  width: 70%;
  min-width: 200px;
  
  ::v-deep .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
  ::v-deep .el-input-group__append button.el-button{
    color: #FFF;
    background-color: #409EFF;
    border-color: #409EFF;
    border-radius: 0;
  }
}


.content {
    flex: 1;
    overflow-x: hidden;
    // height: calc(100vh - 20px);
    // overflow-y: auto;
    ::v-deep .el-form-item.width-name label.el-form-item__label {
    font-size: 16px ;
    font-weight: 600;
  }
  ::v-deep .el-card__header {
    background: #F5F5F5;
    padding: 10px;
  }
  .footer {
    padding: 20px;
    text-align: right;
  }
}
.form-content {
  flex: 1;
  height: calc(100vh - 60px);
    overflow-y: auto;
}
.type-box {
  margin: 10px 0;
}
.tip-icon {
  font-size: 18px;
  color:#409EFF;
  margin-left:8px;
}
.right-dir  {
    height: calc(100vh - 60px);
    overflow-y: auto;
    border-right: 6px solid #F2F2F2;
    max-width: 500px;
    min-width: 300px;
    cursor: ew-resize;
    display: flex;
    flex-direction: column;
    padding: 10px;
}

.price-inquiry-detail{
  display: flex;
  flex-direction: row;
  flex: 1;
  background: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.1);
  /deep/ .el-divider--horizontal{
    margin: 0;
  }
}
.width-name {
    .el-input {
        width: 500px;
    }
    
}
.box-card {
  // margin-top: 10px;
  width: 100%;
   width: 100%;
  ::v-deep .el-card__body {
    padding: 10px;
  }
}
.suplier-title {
  padding-left: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
    height: 30px;
    line-height: 30px;
    background: #F5F5F5;
}
.checkbox-item {
  margin-bottom: 10px;

  ::v-deep .el-checkbox__label {
    white-space: nowrap;
    overflow: hidden;   
    text-overflow: ellipsis;
    width: 250px;
  }
}
.hide-upload-button ::v-deep div.el-upload--picture-card {
  display: none;
}

</style>
